/**
 * Detect fn
 */
export default () => 'Reflect' in self
